import { render, staticRenderFns } from "./text-area.component.vue?vue&type=template&id=1a60ecfb&scoped=true&lang=pug"
import script from "./text-area.component.vue?vue&type=script&lang=ts"
export * from "./text-area.component.vue?vue&type=script&lang=ts"
import style0 from "./text-area.component.vue?vue&type=style&index=0&id=1a60ecfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60ecfb",
  null
  
)

export default component.exports